import { scaleLinear } from "d3-scale";
import { Utilities } from "@learningblocks/exp-constants";

export const { getSwitchButtonAriaLabels } = Utilities.WIDGETS_UTILS;

export const { updateSwitchButtons } = Utilities.WIDGETS_UTILS;

export const getFetchDocumentRequest = Utilities.getFetchWidgetDocumentRequest;

export const getWaveLengthRange = scaleLinear()
  .domain([380, 740])
  .range([0, 200]);
export const getAbsorbanceValue = scaleLinear()
  .domain([5.001, 8.001])
  .range([0, 204]);

export function getCurrentAriaLabel(
  ariaLabelList,
  currentWavelength,
  currentPhValue,
  currentAriaLabel
) {
  if (ariaLabelList.length) {
    const ariaLabels = ariaLabelList.filter((ariaLabelItem) => {
      return (
        ariaLabelItem.wavelengthFrom <= currentWavelength &&
        ariaLabelItem.wavelengthTo >= currentWavelength
      );
    });

    return ariaLabels.find(
      (ariaLabelItem) => ariaLabelItem.phValue === currentPhValue
    );
  } else {
    return currentAriaLabel;
  }
}

export function getAriaLableList(data) {
  try {
    const parsedList = data;
    return parsedList;
  } catch (error) {
    console.error("Failed to parse aria_label_data");
    console.error(error);
    return [];
  }
}
